<template>
  <div
    class="d-flex pa-2 flex-column"
    :style="{
      'margin-bottom': '40px',
      width: '80%',
      'min-height': '550px',
      height: 'min-content',
    }"
  >
    <div class="d-flex pa-5 flex-column">
      <h3 v-if="isOutlet">Outlet Registration</h3>
      <h3 v-else>
        {{ isFromAggregator ? 'Sub Merchant' : 'Merchant' }} Registration
      </h3>
      <p v-if="isOutlet">Silahkan lengkapi detail pendaftaran outlet</p>
      <p v-else>
        Silahkan lengkapi detail pendaftaran
        {{ isFromAggregator ? 'Sub Merchant' : 'Merchant' }}
      </p>
    </div>
    <v-stepper
      class="d-flex flex-column"
      v-model="subStep"
      :style="{ 'margin-bottom': '40px' }"
      elevation="2"
    >
      <v-stepper-header>
        <v-stepper-step
          :complete="subStep > 1"
          step="1"
          color="#e36013"
          :rules="[() => validateStep1]"
          :editable="done"
        >
          Info {{ isFromAggregator ? 'Sub Merchant' : 'Merchant' }}
          <small v-if="!validateStep1">not valid</small>
        </v-stepper-step>

        <v-divider />

        <v-stepper-step
          :complete="subStep > 2"
          step="2"
          color="#e36013"
          :rules="[() => validateStep2]"
          :editable="done"
        >
          Dokumen
          <small v-if="!validateStep2">not valid</small>
        </v-stepper-step>

        <v-divider />

        <v-stepper-step :rules="[() => validateStep3]" step="3" color="#e36013">
          Konfirmasi & Pernyataan
          <small v-if="!validateStep3">not valid</small>
        </v-stepper-step>
      </v-stepper-header>
    </v-stepper>
    <v-stepper
      class="d-flex pa-2 flex-column"
      v-model="subStep"
      :style="{ 'margin-bottom': '40px' }"
      elevation="2"
      v-if="!loadingAutofill"
    >
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card
            class="mb-12"
            height="50px"
            :style="{ 'box-shadow': '0 0 black' }"
            v-if="isFromAggregator"
          >
            <div class="d-flex pa-5 flex-column align-center justify-center">
              <h3 class="mb-5">Aggregator</h3>
            </div>
          </v-card>
          <v-row v-if="isFromAggregator">
            <v-col cols="10" sm="4"> Nama Aggregator </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ namaAggregator }}</v-col>
          </v-row>
          <v-card
            class="mb-12"
            height="50px"
            :style="{ 'box-shadow': '0 0 black' }"
          >
            <div class="d-flex pa-5 flex-column align-center justify-center">
              <h3 class="mb-5">
                Info {{ isFromAggregator ? 'Sub Merchant' : 'Merchant' }}
              </h3>
            </div>
          </v-card>
          <v-row v-if="isOutlet || isFromAggregator">
            <v-col cols="12">
              <v-select
                id="tipeMerchant"
                ref="tipeMerchant"
                outlined
                :label="
                  isFromAggregator ? 'Tipe Sub Merchant *' : 'Tipe Merchant *'
                "
                v-model="tipeMerchant"
                @change="$v.tipeMerchant.$touch()"
                @blur="$v.tipeMerchant.$touch()"
                :error-messages="tipeMerchantErrors"
                :items="listTipeMerchant"
                :disabled="accountTypeParent != null"
                :readonly="accountTypeParent != null"
                :menu-props="accountTypeParent != null ? { value: false } : {}"
                :filled="accountTypeParent != null"
              />
            </v-col>
          </v-row>
          <v-row v-if="isOutlet || isFromAggregator">
            <v-col cols="12">
              <v-select
                id="jenisQR"
                ref="jenisQR"
                outlined
                label="Jenis QR *"
                v-model="jenisQR"
                @change="$v.jenisQR.$touch()"
                @blur="$v.jenisQR.$touch()"
                :error-messages="jenisQRErrors"
                :readonly="tipeMerchant == ''"
                :filled="tipeMerchant == ''"
                :items="isFromAggregator ? qrItemsFiltered : qrItems"
              />
            </v-col>
          </v-row>
          <AggregatorInterfaceField ref="aggregatorInterfaceField" v-if="(isFromAggregator || isOutlet) && isIncludeAPI" />
          <v-row v-if="!isFromAggregator">
            <v-col cols="12">
              <v-text-field
                id="noRekening"
                ref="noRekening"
                outlined
                label="Nomor Rekening BNI *"
                v-model="noRekening"
                @change="$v.noRekening.$touch()"
                @blur="$v.noRekening.$touch()"
                :error-messages="noRekeningErrors"
                :readonly="!isOutlet"
                :filled="!isOutlet"
                :loading="isloadingRekening"
              />
            </v-col>
          </v-row>
          <v-row v-if="isCorporate">
            <v-col cols="12">
              <v-text-field
                id="companyName"
                ref="companyName"
                outlined
                label="Nama Perusahaan *"
                v-model="companyName"
                @change="$v.companyName.$touch()"
                @blur="$v.companyName.$touch()"
                :error-messages="companyNameErrors"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                id="merchantName"
                ref="merchantName"
                outlined
                :label="
                  isFromAggregator ? 'Nama Sub Merchant *' : 'Nama Merchant *'
                "
                v-model="merchantName"
                @change="$v.merchantName.$touch()"
                @blur="$v.merchantName.$touch()"
                :error-messages="merchantNameErrors"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                id="merchantOwnerName"
                ref="merchantOwnerName"
                outlined
                label="Nama Pemilik Usaha *"
                v-model="merchantOwnerName"
                @change="$v.merchantOwnerName.$touch()"
                @blur="$v.merchantOwnerName.$touch()"
                :error-messages="merchantOwnerNameErrors"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                id="noKTP"
                ref="noKTP"
                outlined
                label="Nomor KTP Pemilik Usaha *"
                v-model="noKTP"
                :counter="16"
                @change="$v.noKTP.$touch()"
                @blur="$v.noKTP.$touch()"
                :error-messages="noKTPErrors"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                id="noNPWP"
                ref="noNPWP"
                v-if="!isCorporate"
                outlined
                append-icon="mdi-orbit-variant"
                suffix="Samakan dengan No KTP"
                label="Nomor NPWP Pemilik Usaha"
                v-model="noNPWP"
                :counter="16"
                @change="$v.noNPWP.$touch()"
                @blur="$v.noNPWP.$touch()"
                @click:append="copyNoKTPtoNPWP"
                :error-messages="noNPWPErrors"
              />
              <v-text-field
                id="noNPWP"
                ref="noNPWP"
                v-else
                outlined
                label="Nomor NPWP Perusahaan *"
                v-model="noNPWP"
                :counter="16"
                @change="$v.noNPWP.$touch()"
                @blur="$v.noNPWP.$touch()"
                :error-messages="noNPWPErrors"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                id="email"
                ref="email"
                outlined
                label="Email Pemilik Usaha *"
                v-model="email"
                @change="$v.email.$touch()"
                @blur="$v.email.$touch()"
                :error-messages="emailErrors"
                :readonly="(!isOutlet && !isFromAggregator) || isOutlet"
                :filled="(!isOutlet && !isFromAggregator) || isOutlet"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                id="noHandphone"
                ref="noHandphone"
                outlined
                label="No. Handphone Pemilik Usaha *"
                v-model="noHandphone"
                @change="$v.noHandphone.$touch()"
                @blur="$v.noHandphone.$touch()"
                :error-messages="noHandphoneErrors"
                :readonly="!isOutlet && !isFromAggregator"
                :filled="!isOutlet && !isFromAggregator"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                id="noHandphoneMerchant"
                ref="noHandphoneMerchant"
                outlined
                :label="
                  isFromAggregator
                    ? 'No. Handphone Sub Merchant *'
                    : 'No. Handphone Merchant *'
                "
                v-model="noHandphoneMerchant"
                @change="$v.noHandphoneMerchant.$touch()"
                @blur="$v.noHandphoneMerchant.$touch()"
                :error-messages="noHandphoneMerchantErrors"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="3">
              <v-autocomplete
                id="areaCode"
                ref="areaCode"
                clearable
                v-model="areaCode"
                :items="itemsAreaCode"
                item-text="kode_area"
                item-value="kode_area"
                label="Kode Area"
                :loading="isLoadingAreaCode"
                :search-input.sync="searchAreaCode"
                hide-selected
                outlined
              >
                <template v-slot:item="data">
                  <template v-if="typeof data.item != 'object'">
                    <v-list-item-content>{{ data.item }}</v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        data.item.kode_area
                      }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                        data.item.wilayah
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="9">
              <v-text-field
                id="noTelpMerchant"
                ref="noTelpMerchant"
                v-if="!isCorporate"
                outlined
                :label="
                  isFromAggregator
                    ? 'No. Telepon Sub Merchant *'
                    : 'No. Telepon Merchant'
                "
                @change="$v.noTelpMerchant.$touch()"
                @blur="$v.noTelpMerchant.$touch()"
                :error-messages="noTelpMerchantErrors"
                v-model="noTelpMerchant"
              />
              <v-text-field
                id="noTelpMerchant"
                ref="noTelpMerchant"
                v-else
                outlined
                label="No. Telepon Perusahaan"
                @change="$v.noTelpMerchant.$touch()"
                @blur="$v.noTelpMerchant.$touch()"
                :error-messages="noTelpMerchantErrors"
                v-model="noTelpMerchant"
              />
            </v-col>
          </v-row>
          
          <v-row>
            <v-col cols="12">
              <QrChannelField ref="qrChannelField" :jenisQR="jenisQR" />
            </v-col>
          </v-row>
          <v-row>
             <v-col cols="12" sm="3">
               <v-select
                id="merchantModel"
                ref="merchantModel"
                :label="'Model Usaha *'"
                :items="listMerchantModel"
                item-text="text"
                item-value="value"
                v-model="merchantModel"
                @change="$v.merchantModel.$touch()"
                @blur="$v.merchantModel.$touch()"
                :error-messages="merchantModelErrors"
                outlined
              />
            </v-col>
            <v-col cols="12" sm="9">
              <v-autocomplete
                id="jenisUsaha"
                ref="jenisUsaha"
                clearable
                v-model="jenisUsaha"
                :items="itemsJenisUsaha"
                item-text="mcc_name"
                return-object
                :filter="customFilter"
                :error-messages="jenisUsahaErrors"
                label="Jenis Usaha *"
                @change="$v.jenisUsaha.$touch()"
                @blur="$v.jenisUsaha.$touch()"
                :loading="isLoadingJenisUsaha"
                hide-selected
                single-line
                outlined
              >
                <template v-slot:item="data">
                  <template v-if="typeof data.item != 'object'">
                    <v-list-item-content>{{ data.item }}</v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title
                        >{{ data.item.mcc }} -
                        {{ data.item.mcc_name }}</v-list-item-title
                      >
                    </v-list-item-content>
                  </template>
                </template>
                <template v-slot:selection="data">
                  {{ data.item.mcc }} -
                  {{ data.item.mcc_name }}
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-select
                v-if="!isCorporate"
                id="merchantCriteria"
                ref="merchantCriteria"
                :label="
                  isFromAggregator
                    ? 'Kriteria Sub Merchant *'
                    : 'Kriteria Merchant *'
                "
                :items="listCriteria"
                return-object
                v-model="merchantCriteria"
                @change="$v.merchantCriteria.$touch()"
                @blur="$v.merchantCriteria.$touch()"
                :error-messages="merchantCriteriaErrors"
                outlined
              />
              <v-select
                v-else
                id="merchantCriteria"
                ref="merchantCriteria"
                :label="
                  isFromAggregator
                    ? 'Kriteria Sub Merchant *'
                    : 'Kriteria Merchant *'
                "
                :items="listCriteriaCorporate"
                return-object
                v-model="merchantCriteria"
                @change="$v.merchantCriteria.$touch()"
                @blur="$v.merchantCriteria.$touch()"
                :error-messages="merchantCriteriaErrors"
                outlined
              />
            </v-col>
          </v-row>
          <v-row v-if="showMDRForm">
            <v-col cols="12">
              <v-checkbox
                id="isSpecialMdr"
                v-model="isSpecialMdr"
                label="MDR Khusus"
                color="primary"
              />
            </v-col>
          </v-row>
          <v-row v-if="showMDRForm">
            <v-col cols="23">
              <v-text-field
                id="mdrOnUs"
                ref="mdrOnUs"
                v-model="mdrOnUs"
                label="Input MDR On Us *"
                @change="$v.mdrOnUs.$touch()"
                @blur="$v.mdrOnUs.$touch()"
                :error-messages="mdrOnUsErrors"
                outlined
                :loading="loadingMdr"
                :disabled="!isSpecialMdr"
                :filled="!isSpecialMdr"
              />
            </v-col>
          </v-row>
          <v-row v-if="showMDRForm">
            <v-col cols="12">
              <v-text-field
                id="mdrOffUs"
                ref="mdrOffUs"
                label="Input MDR Off Us *"
                v-model="mdrOffUs"
                @change="$v.mdrOffUs.$touch()"
                @blur="$v.mdrOffUs.$touch()"
                :error-messages="mdrOffUsErrors"
                outlined
                :loading="loadingMdr"
                :disabled="!isSpecialMdr"
                :filled="!isSpecialMdr"
              />
            </v-col>
          </v-row>
          <v-row v-if="showMDRForm && isSpecialMdr">
            <v-col cols="12">
              <div id="mdrFile">
                <FileUploadDropzone
                  v-model="mdrFile"
                  label="Dokumen MDR Khusus"
                  placeholder="Drag & drop file PDF atau klik untuk memilih"
                  :allowed-extensions="['pdf']"
                  :max-size="1048576"
                  upload-icon="mdi-cloud-upload"
                  file-icon="mdi-file-pdf-box"
                  progress-color="teal"
                  :errors="mdrFileErrors"
                  @change="onMdrFileChange"
                  @remove="onMdrFileRemove"
                  ref="mdrFileUpload"
                />
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                id="alamatMerchant"
                ref="alamatMerchant"
                outlined
                :label="
                  isFromAggregator
                    ? 'Alamat Sub Merchant *'
                    : 'Alamat Merchant *'
                "
                v-model="alamatMerchant"
                @change="$v.alamatMerchant.$touch()"
                @blur="$v.alamatMerchant.$touch()"
                :error-messages="alamatMerchantErrors"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                id="kodepos"
                ref="kodepos"
                clearable
                v-model="kodepos"
                :items="itemsKodepos"
                return-object
                item-text="text"
                item-value="id"
                :error-messages="kodeposErrors"
                label="Kota, Kecamatan, Kode Pos *"
                @change="$v.kodepos.$touch()"
                @blur="$v.kodepos.$touch()"
                :loading="isLoadingKodepos"
                :search-input.sync="searchKodepos"
                hide-selected
                outlined
              />
            </v-col>
          </v-row>
          <RegionalMappingFields
            :bcko.sync="bcko"
            :cmer.sync="cmer"
            :referralCode.sync="rmReferalCode"
            :itemsBcko="itemsBcko"
            :searchBcko.sync="searchBcko"
            :loadingBcko="isLoadingBcko"
            :itemsCmer="itemsCmer"
            :searchCmer.sync="searchCmer"
            :loadingCmer="isLoadingCmer"
            :bckoErrors="bckoErrors"
            :cmerErrors="cmerErrors"
            :referralCodeErrors="rmReferalCodeErrors"
            :disableBcko="false"
            :disableCmer="false"
            :showSubMerchantInfo="false"
            :infoType="fieldInfoType"
            @touch-referral="$v.rmReferalCode.$touch()"
            @focus-bcko="onFocusBcko"
            @focus-cmer="onFocusCmer"
          />
          <v-card
            v-if="jenisQR == '2'"
            class="mb-12"
            height="50px"
            :style="{ 'box-shadow': '0 0 black' }"
          >
            <div class="d-flex pa-5 flex-column align-center justify-center">
              <h3 class="mb-5">Endpoint</h3>
            </div>
          </v-card>

          <v-row v-if="isAPI && isVersionSnap">
            <v-col cols="12">
              <CallbackPartnerField 
                ref="callbackPartnerField"
                :partnerId.sync="callbackPartnerId"
                :partnerClientSecret.sync="callbackPartnerClientSecret"
                :isFromAggregator="isFromAggregator"
                :externalPartnerIdErrors="beCallbackPartnerIdErrors"
                :externalClientSecretErrors="beCallbackPartnerClientSecretErrors"
              />
            </v-col>
          </v-row>

          <v-row v-if="isAPI && isVersionSnap">
            <v-col cols="12">
              <v-text-field
                id="callbackPartnerUrlToken"
                ref="callbackPartnerUrlToken"
                outlined
                label="Callback Partner URL Token *"
                v-model="callbackPartnerUrlToken"
                @change="$v.callbackPartnerUrlToken.$touch()"
                @blur="$v.callbackPartnerUrlToken.$touch()"
                :error-messages="callbackPartnerUrlTokenErrors"
                :filled="isFromAggregator"
                :readonly="isFromAggregator"
              />
            </v-col>
          </v-row>

        <v-row v-if="isAPI && isVersionSnap">
          <v-col cols="12">
            <v-textarea
              id="privateKeyPartner"
              ref="privateKeyPartner"
              outlined
              label="Public Key Partner *"
              v-model="privateKeyPartner"
              @change="$v.privateKeyPartner.$touch()"
              @blur="$v.privateKeyPartner.$touch()"
              :error-messages="privateKeyPartnerErrors"
              :filled="isFromAggregator"
              :readonly="isFromAggregator"
              rows="4"
            />
          </v-col>
        </v-row>

          <v-row v-if="jenisQR == '2'">
            <v-col cols="12">
              <v-text-field
                id="endpointURL"
                ref="endpointURL"
                outlined
                label="URL *"
                v-model="endpointURL"
                @change="$v.endpointURL.$touch()"
                @blur="$v.endpointURL.$touch()"
                :error-messages="endpointURLErrors"
                :filled="isFromAggregator"
                :readonly="isFromAggregator"
              />
              <FieldInfoHelper
                :show="isFromAggregator"
                :type="fieldInfoType"
                :outlined="true"
              />
            </v-col>
          </v-row>
          <v-row v-if="jenisQR == '2'">
            <v-col cols="12">
              <v-text-field
                id="ipAddress"
                ref="ipAddress"
                outlined
                label="IP Address *"
                v-model="ipAddress"
                @change="$v.ipAddress.$touch()"
                @blur="$v.ipAddress.$touch()"
                :error-messages="ipAddressErrors"
                :filled="isFromAggregator"
                :readonly="isFromAggregator"
              />
              <FieldInfoHelper
                :show="isFromAggregator"
                :type="fieldInfoType"
                :outlined="true"
              />
            </v-col>
          </v-row>

           <v-card
            class="mb-12"
            height="50px"
            :style="{ 'box-shadow': '0 0 black' }"
          >
            <div class="d-flex pa-5 flex-column align-center justify-center">
              <h3 class="mb-5">Approver</h3>
            </div>
          </v-card>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                id="IDApprover1"
                ref="IDApprover1"
                outlined
                label="ID Approver 1 *"
                clearable
                v-model="IDApprover1"
                :items="itemsApprovalId1"
                item-id="id"
                item-text="username"
                return-object
                @change="$v.IDApprover1.$touch()"
                @blur="$v.IDApprover1.$touch()"
                :error-messages="IDApprover1Errors"
                :loading="isLoadingApprovalId1"
                :search-input.sync="searchApprovalId1"
                hide-selected
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                id="IDApprover2"
                ref="IDApprover2"
                outlined
                label="ID Approver 2 *"
                clearable
                v-model="IDApprover2"
                :items="itemsApprovalId2"
                item-id="id"
                item-text="username"
                return-object
                @change="$v.IDApprover2.$touch()"
                @blur="$v.IDApprover2.$touch()"
                :error-messages="IDApprover2Errors"
                :loading="isLoadingApprovalId2"
                :search-input.sync="searchApprovalId2"
                hide-selected
              />
            </v-col>
          </v-row>

          <v-row class="pa-5">
            <v-btn
              small
              color="warning"
              dark
              @click="prevStep"
              :style="{ margin: '2px' }"
            >
              <v-icon dark left> mdi-arrow-left </v-icon>Kembali
            </v-btn>
            <v-spacer />
            <v-btn
              small
              color="primary"
              dark
              @click="changeSubStep(2)"
              :style="{ margin: '2px' }"
            >
              Lanjut
              <v-icon dark right> mdi-arrow-right </v-icon>
            </v-btn>
          </v-row>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-card
            class="mb-12"
            height="50px"
            :style="{ 'box-shadow': '0 0 black' }"
          >
            <div class="d-flex pa-5 flex-column align-center justify-center">
              <h3 class="mb-5">Dokumen</h3>
            </div>
          </v-card>

          <v-row>
            <v-col cols="12">
              <p>
                Apakah di lokasi yang anda daftarkan ini sudah terdapat QRIS
                dari institusi / bank lain ?
              </p>
              <v-radio-group
                v-model="isHaveQRIS"
                row
                :style="{ 'margin-left': '25px' }"
              >
                <v-radio label="Belum" value="0" />
                <v-radio label="Sudah" value="1" />
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row v-if="isHaveQRIS == '1'">
            <v-col cols="12">
              <v-text-field
                id="nmid"
                ref="nmid"
                outlined
                label="NMID *"
                v-model="nmid"
                :counter="20"
                @change="$v.nmid.$touch()"
                @blur="$v.nmid.$touch()"
                :error-messages="nmidErrors"
              />
            </v-col>
          </v-row>
          <v-row class="pa-5">
            <v-btn
              small
              color="warning"
              dark
              @click="changeSubStep(1)"
              :style="{ margin: '2px' }"
            >
              <v-icon dark left> mdi-arrow-left </v-icon>Kembali
            </v-btn>
            <v-spacer />
            <v-btn
              small
              color="primary"
              dark
              @click="changeSubStep(3)"
              :style="{ margin: '2px' }"
            >
              Lanjut
              <v-icon dark right> mdi-arrow-right </v-icon>
            </v-btn>
          </v-row>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-card
            class="mb-12"
            height="50px"
            :style="{ 'box-shadow': '0 0 black' }"
            v-if="isFromAggregator"
          >
            <div class="d-flex pa-5 flex-column align-center justify-center">
              <h3 class="mb-5" :style="{ color: 'orange' }">Aggregator</h3>
            </div>
          </v-card>
          <v-row v-if="isFromAggregator">
            <v-col cols="10" sm="4"> Nama Aggregator </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ namaAggregator }}</v-col>
          </v-row>
          <v-card
            class="mb-12"
            height="50px"
            :style="{ 'box-shadow': '0 0 black' }"
          >
            <div class="d-flex pa-5 flex-column align-center justify-center">
              <h3 class="mb-5" :style="{ color: 'orange' }">
                Info {{ isFromAggregator ? 'Sub Merchant' : 'Merchant' }}
              </h3>
            </div>
          </v-card>
          <v-row>
            <v-col cols="10" sm="4">
              Tipe {{ isFromAggregator ? 'Sub Merchant' : 'Merchant' }}
            </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ tipeMerchantText }} </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" sm="4"> Jenis QR </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ qrTypeText }} </v-col>
          </v-row>
          <v-row v-if="isAPI">
            <v-col cols="10" sm="4"> Versi Client </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ qrVersionText }} </v-col>
          </v-row>
          <v-row v-if="!isFromAggregator">
            <v-col cols="10" sm="4"> Nomor Rekening BNI </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ noRekening }} </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" sm="4">
              Nama {{ isFromAggregator ? 'Sub Merchant' : 'Merchant' }}
            </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ merchantName }} </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" sm="4"> Nama Pemilik Usaha </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ merchantOwnerName }} </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" sm="4"> Nomor KTP Pemilik Usaha </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ text(noKTP) }} </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" sm="4">
              Nomor NPWP
              {{ tipeMerchant == 1 ? 'Pemilik Usaha' : 'Perusahaan' }}</v-col
            >
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ text(noNPWP) }} </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" sm="4"> Email Pemilik Usaha </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ email }} </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" sm="4"> No Handphone Pemilik Usaha </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ noHandphone }} </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" sm="4">
              No Handphone {{ isFromAggregator ? 'Sub Merchant' : 'Merchant' }}
            </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ noHandphoneMerchant }} </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" sm="4">
              No Telepon {{ isFromAggregator ? 'Sub Merchant' : 'Merchant' }}
            </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              {{ merchantPhone == ' ' ? '( not set )' : merchantPhone }}</v-col
            >
          </v-row>
          <v-row>
            <v-col cols="12">
              <InterfacePreview 
                :channelQr="channelQrObject"
                :merchantModel="merchantModel"
                :merchantModelList="listMerchantModel"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" sm="4"> Jenis Usaha </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ namaJenisUsaha }} </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" sm="4"> MDR On-Us </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ mdrOnUs }}% </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" sm="4"> MDR Off-Us </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ mdrOffUs }}% </v-col>
          </v-row>
          <v-row v-if="isSpecialMdr && mdrFile">
            <v-col cols="10" sm="4"> Dokumen MDR Khusus </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <div class="mdr-file-preview-item">
                <v-icon color="red darken-1" class="mr-2">mdi-file-pdf-box</v-icon>
                <span class="file-name-text">{{ mdrFile.name }}</span>
                <v-btn
                  icon
                  small
                  color="primary"
                  @click="previewMdrFile"
                  title="Preview"
                  class="ml-2"
                >
                  <v-icon small>mdi-eye</v-icon>
                </v-btn>
                <v-btn
                  icon
                  small
                  color="primary"
                  @click="downloadMdrFile"
                  title="Download"
                  class="ml-1"
                >
                  <v-icon small>mdi-download</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" sm="4">
              Kriteria {{ isFromAggregator ? 'Sub Merchant' : 'Merchant' }}
            </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ namaCriteriaMerchant }} </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" sm="4">
              Alamat {{ isFromAggregator ? 'Sub Merchant' : 'Merchant' }}
            </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ alamatMerchant }} </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" sm="4"> Kota, Kecamatan, Kode Pos </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              {{ `${namaKabupaten}, ${namaKecamatan}, ${namaKodepos}` }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" sm="4"> KODE BC/KO </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ bckoPreviewText }} </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" sm="4"> Merchant Category Segment </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ cmerPreviewText }} </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" sm="4"> Referral Code </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              {{ rmReferalCode == '' ? '( not set )' : rmReferalCode }}
            </v-col>
          </v-row>
          <v-row v-if="isAPI && isVersionSnap" >
            <v-col cols="10" sm="4"> Callback Partner ID </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ callbackPartnerId }} </v-col>
          </v-row>
          <v-row v-if="isAPI && isVersionSnap" >
            <v-col cols="10" sm="4"> Callback Partner Client Secret </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ callbackPartnerClientSecret }} </v-col>
          </v-row>
          <v-row v-if="isAPI && isVersionSnap" >
            <v-col cols="10" sm="4"> Callback Partner URL Token </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ callbackPartnerUrlToken }} </v-col>
          </v-row>
          <v-row v-if="isAPI && isVersionSnap" >
            <v-col cols="10" sm="4"> Public Key Partner </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm class="d-flex align-center">
              <v-textarea
                v-model="privateKeyPartner"
                outlined
                disabled
                dense
                readonly
                rows="2"
                class="fixed-height-textarea"
                hide-details
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row v-if="isAPI" >
            <v-col cols="10" sm="4"> URL </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7"> {{ endpointURL }} </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" sm="4"> ID Approver 1 </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              {{ IDApprover1 == null ? '' : IDApprover1.username }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" sm="4"> ID Approver 2 </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              {{ IDApprover2 == null ? '' : IDApprover2.username }}
            </v-col>
          </v-row>

          <v-card
            class="mb-12"
            height="50px"
            :style="{ 'box-shadow': '0 0 black' }"
          >
            <div class="d-flex pa-5 flex-column align-center justify-center">
              <h3 class="mb-5" :style="{ color: 'orange' }">Dokumen</h3>
            </div>
          </v-card>

          <v-row>
            <v-col cols="10" sm="4"> NMID </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              {{ nmid == '' ? '( not set )' : nmid }}
            </v-col>
          </v-row>
          <v-card
            class="mb-12"
            height="50px"
            :style="{ 'box-shadow': '0 0 black' }"
          >
            <div class="d-flex pa-5 flex-column align-center justify-center">
              <h3 class="mb-5" :style="{ color: 'orange' }">
                Syarat & Ketentuan
              </h3>
            </div>
          </v-card>
          <v-card
            elevation="2"
            :style="{
              height: '350px',
              overflow: 'auto',
              margin: '10px',
            }"
          >
            <v-fab-transition>
              <v-btn
                class="mx-2"
                fab
                dark
                small
                color="primary"
                :style="{
                  position: 'absolute',
                  top: '0',
                  right: '0',
                  margin: '10px',
                  'z-index': '2',
                }"
                @click="printThePDF(pdfFileSK)"
              >
                <v-icon dark> mdi-printer </v-icon>
              </v-btn>
            </v-fab-transition>
            <pdf
              ref="pdfSK"
              :src="pdfFileSK"
              @num-pages="numPages = $event"
            />
            <div v-for="i in numPages" :key="i" style="margin-bottom: 12px">
              <pdf :src="pdfFileSK" :page="i" />
            </div>
          </v-card>
          <v-row>
            <v-checkbox
              id="sk"
              ref="sk"
              v-model="sk"
              :label="`Dengan ini saya menyatakan bahwa form ini telah saya isi dengan benar, dan saya setuju dengan semua syarat dan ketentuan.`"
              :style="{ margin: '20px' }"
              @change="$v.sk.$touch()"
              @blur="$v.sk.$touch()"
              :error-messages="skErrors"
            />
          </v-row>
          <v-card
            class="mb-12"
            height="50px"
            :style="{ 'box-shadow': '0 0 black' }"
          >
            <div class="d-flex pa-5 flex-column align-center justify-center">
              <h3 class="mb-5" :style="{ color: 'orange' }">
                <!-- Input MID & TID -->
                Input MID
              </h3>
            </div>
          </v-card>
          <v-row>
            <v-col cols="12">
              <v-text-field
                id="mid"
                ref="mid"
                outlined
                label="MID"
                :counter="midMinLength"
                @change="$v.mid.$touch()"
                @blur="$v.mid.$touch()"
                :error-messages="midErrors"
                v-model="mid"
              />
            </v-col>
          </v-row>

          <v-row v-if="onUpload" class="pa-5">
            <h4>{{ uploadName }}</h4>
            <v-progress-linear
              v-model="uploadProgress"
              :active="onUpload"
              :query="true"
            />
          </v-row>
          <v-row v-if="isLoading" class="pa-5">
            <v-progress-linear :indeterminate="isLoading" />
          </v-row>
          <v-row class="pa-5">
            <v-btn
              small
              color="warning"
              :disabled="isLoading || onUpload"
              @click="changeSubStep(2)"
              :style="{ margin: '2px' }"
            >
              <v-icon dark left> mdi-arrow-left </v-icon>Kembali
            </v-btn>
            <v-spacer />
            <v-btn
              small
              color="primary"
              :disabled="isLoading || onUpload"
              @click="nextStep"
              :style="{ margin: '2px' }"
            >
              Lanjut
              <v-icon dark right> mdi-arrow-right </v-icon>
            </v-btn>
          </v-row>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <div v-else>
      <v-progress-linear indeterminate color="yellow darken-2" />
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import {
  required,
  email,
  numeric,
  maxLength,
  minLength,
  alphaNum,
  ipAddress,
} from 'vuelidate/lib/validators';
import printJS from 'print-js';
import {
  dataListMerchantCriteria,
  dataListMerchantCriteriaCorporate,
  validations,
  dataAllQrType,
  dataQrType,
  dataListIdApprover,
  scrollOptions,
  dataUserRoles,
  dataTipeMerchantOnboarding,
  qrByMerchantType,
  dataVarcharMaxLength,
  dataDelayServiceHit,
  listMerchantModel,
  dataCptsMdrValues
} from '../../store/params';
import {
  text,
  isEmpty,
  date,
  regexDoesNotContainPipe,
  regexNumericDecimal,
  regexAlphanumChar,
  regexNumberValidate,
  checkRegexAlphanumChar,
} from '../../lib/helpers';
import validationRules from './validationRules';

import { clientType } from "../merchant-callback-management/attributes";
import InterfacePreview from "./fields/interface/InterfacePreview.vue";
import AggregatorInterfaceField from "./fields/interface/AggregatorInterfaceField.vue";
import QrChannelField from "./fields/QrChannelField.vue";
import CallbackPartnerField from "./fields/CallbackPartnerField.vue";
import RegionalMappingFields from "./fields/RegionalMappingFields.vue";
import FieldInfoHelper from "@/components/inputer/FieldInfoHelper.vue";
import regionalMappingValidationMixin from './fields/regionalMappingValidation';
import regionalMappingMixin from './fields/regionalMappingMixin';
import FileUploadDropzone from "../form/FileUploadDropzone.vue";

export default {
  name: 'step6',
  components: {
    pdf: () => import('vue-pdf'),
    InterfacePreview,
    AggregatorInterfaceField,
    QrChannelField,
    CallbackPartnerField,
    RegionalMappingFields,
    FieldInfoHelper,
    FileUploadDropzone
  },
  mixins: [validationMixin, regionalMappingValidationMixin, regionalMappingMixin],
  validations: {
    ...regionalMappingValidationMixin.validations,
    merchantModel: {
      required,
    },
    endpointURL: { 
      required() {
        if (this.isAPI) {
          return !!this.endpointURL;
        }
        return true;
      },
      validFormat: validationRules.validators.endpointURLValidator
    },
    callbackPartnerId: { 
      required() {
        if (this.isAPI && this.isVersionSnap) {
          return !!this.callbackPartnerId;
        }
        return true;
      },
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.client_partner_id == null ||
            this.errorValidation.client_partner_id.length < 1)
        );
      }
    },
    callbackPartnerClientSecret: { 
      required() {
        if (this.isAPI && this.isVersionSnap) {
          return !!this.callbackPartnerClientSecret;
        }
        return true;
      },
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.client_secret == null ||
            this.errorValidation.client_secret.length < 1)
        );
      }
    },
    callbackPartnerUrlToken: { 
      required() {
        if (this.isAPI && this.isVersionSnap) {
          return !!this.callbackPartnerUrlToken;
        }
        return true;
      },
      validFormat: validationRules.validators.callbackPartnerUrlTokenValidator
    },
    privateKeyPartner: { 
      required() {
        if (this.isAPI && this.isVersionSnap) {
          return !!this.privateKeyPartner;
        }
        return true;
      },
      validFormat: validationRules.validators.privateKeyPartnerValidator,
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.public_key_inbound == null ||
            this.errorValidation.public_key_inbound.length < 1)
        );
      }
    },
    tipeMerchant: {
      required() {
        if (this.isOutlet || this.isFromAggregator) {
          return this.tipeMerchant != '';
        }
        return true;
      },
    },
    jenisQR: {
      required() {
        if (this.isOutlet || this.isFromAggregator) {
          return !isEmpty(this.jenisQR);
        }
        return true;
      },
    },
    noRekening: {
      required() {
        if (!this.isFromAggregator) {
          return this.noRekening != '';
        }
        return true;
      },

      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.account_number == null ||
            this.errorValidation.account_number.length < 1)
        );
      },
      isRekVc() {
        return (
          this.isFromAggregator ||
          this.noRekening.length == 9 ||
          this.noRekening.length == 10 ||
          this.noRekening.length == 16
        );
      },
      numeric,
    },
    companyName: {
      required() {
        if (this.isCorporate) {
          return this.companyName != '';
        }
        return true;
      },
      maxLength: maxLength(dataVarcharMaxLength),
      alphanumChar() {
        if (this.isCorporate) {
          return checkRegexAlphanumChar(this.companyName);
        }
        return true;
      },
    },
    merchantName: {
      required,
      alphanumChar: regexAlphanumChar,
      numberValidate: regexNumberValidate,
      maxLength: maxLength(dataVarcharMaxLength),
      merchantCriteriaMcc() {
        return this.criteriaQuote || this.criteriaQuote === null;
      },
    },
    merchantOwnerName: {
      required,
      alphanumChar: regexAlphanumChar,
      maxLength: maxLength(dataVarcharMaxLength),
    },
    noKTP: {
      required,
      numeric,
      maxLength: maxLength(16),
      minLength() {
        if (!this.isCorporate) {
          return this.noKTP.length == 16;
        }
        if (this.noKTP.length > 0) {
          return this.noKTP.length == 16;
        }
        return true;
      },
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.ktp_no == null ||
            this.errorValidation.ktp_no.length < 1)
        );
      },
    },
    noNPWP: {
      required() {
        if (this.isCorporate) {
          return this.noNPWP != '';
        }
        return true;
      },
      numeric,
      maxLength() {
        if (this.isCorporate) {
          return this.noNPWP.length == 16;
        }
        return true;
      },
      minLength() {
        if (this.isCorporate) {
          return this.noNPWP.length == 16;
        }
        if (this.noNPWP.length > 0) {
          return this.noNPWP.length == 16;
        }
        return true;
      },
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.npwp_no == null ||
            this.errorValidation.npwp_no.length < 1)
        );
      },
    },
    email: {
      required,
      email,
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.email == null ||
            this.errorValidation.email.length < 1)
        );
      },
      doesNotContainPipe: regexDoesNotContainPipe,
    },
    noHandphone: {
      required,
      numeric,
      maxLength: maxLength(15),
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.mobile_phone == null ||
            this.errorValidation.mobile_phone.length < 1)
        );
      },
    },
    noHandphoneMerchant: {
      required,
      numeric,
      maxLength: maxLength(15),
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.merchant_mobile_phone == null ||
            this.errorValidation.merchant_mobile_phone.length < 1)
        );
      },
    },
    noTelpMerchant: { numeric, maxLength: maxLength(15) },
    jenisUsaha: {
      required,
      jenisUsahaChange() {
        return this.jenisUsahaQuote || false;
      },
    },
    mdrOnUs: {
      required,
      numericDecimal: regexNumericDecimal,
      minVal() {
        return this.mdrOnUs >= process.env.VUE_APP_MIN_MDR;
      },
      maxVal() {
        if (this.isCPTS) {
          const isMerchant = this.tipeMerchant === '1' && !this.isFromAggregator;
          const maxValue = isMerchant
            ? dataCptsMdrValues.merchant.mdr_on_us 
            : dataCptsMdrValues.sub_merchant.mdr_on_us;
          return parseFloat(this.mdrOnUs) <= maxValue;
        }
        return parseFloat(this.mdrOnUs) <= parseFloat(process.env.VUE_APP_MAX_MDR);
      },
      isValidMdr() {
        if (this.errorValidation == null) {
          return true;
        }
        return (
          this.errorValidation.mdr_on_us == null ||
          this.errorValidation.mdr_on_us.length < 1
        );
      },
    },
    mdrOffUs: {
      required,
      numericDecimal: regexNumericDecimal,
      minVal() {
        return this.mdrOffUs >= process.env.VUE_APP_MIN_MDR;
      },
      maxVal() {
        if (this.isCPTS) {
          const isMerchant = this.tipeMerchant === '1' && !this.isFromAggregator;
          const maxValue = isMerchant
            ? dataCptsMdrValues.merchant.mdr_off_us 
            : dataCptsMdrValues.sub_merchant.mdr_off_us;
          return parseFloat(this.mdrOffUs) <= maxValue;
        }

        return parseFloat(this.mdrOffUs) <= parseFloat(process.env.VUE_APP_MAX_MDR);
      },
      isValidMdr() {
        if (this.errorValidation == null) {
          return true;
        }
        return (
          this.errorValidation.mdr_off_us == null ||
          this.errorValidation.mdr_off_us.length < 1
        );
      },
    },
    mdrFile: {
      required() {
        if (this.isSpecialMdr) {
          return this.mdrFile != null;
        }
        return true;
      },
      maxSize() {
        if (this.mdrFile != null) {
          return this.mdrFile.size <= 1000000;
        }
        return true;
      },
      fileType() {
        if (this.mdrFile != null) {
          return this.mdrFile.type === 'application/pdf';
        }
        return true;
      },
    },
    merchantCriteria: {
      required,
      criteriaRange() {
        return this.rangeUbe;
      },
      criteriaUre() {
        return this.rangeUre;
      },
    },
    alamatMerchant: {
      required,
      doesNotContainPipe: regexDoesNotContainPipe,
      maxLength: maxLength(dataVarcharMaxLength),
    },
    kodepos: {
      required,
      isRegistered() {
        if (this.errorValidation == null) {
          return true;
        }
        return (
          this.errorValidation.postal_code == null ||
          this.errorValidation.postal_code.length < 1
        );
      },
    },
    ipAddress: { ipAddress, maxLength: maxLength(dataVarcharMaxLength) },
    IDApprover1: {
      required,
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.approver_1 == null ||
            this.errorValidation.approver_1.length < 1)
        );
      },
    },
    IDApprover2: {
      required,
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.approver_2 == null ||
            this.errorValidation.approver_2.length < 1)
        );
      },
    },
    ktpFile: {
      maxSize() {
        if (this.ktpFile != null) {
          return this.ktpFile.size <= validations.file_ktp.max * 1000;
        }
        return true;
      },
      fileType() {
        if (this.ktpFile != null) {
          return !!validations.file_ktp.type.includes(
            this.ktpFile.type.toLowerCase()
          );
        }
        return true;
      },
    },
    npwpFile: {
      maxSize() {
        if (this.npwpFile != null) {
          return this.npwpFile.size <= validations.file_npwp.max * 1000;
        }
        return true;
      },
      fileType() {
        if (this.npwpFile != null) {
          return !!validations.file_npwp.type.includes(
            this.npwpFile.type.toLowerCase()
          );
        }
        return true;
      },
    },
    fotoMerchantFile: {
      maxSize() {
        if (this.fotoMerchantFile != null) {
          return (
            this.fotoMerchantFile.size <=
            validations.file_foto_merchant.max * 1000
          );
        }
        return true;
      },
      fileType() {
        if (this.fotoMerchantFile != null) {
          return !!validations.file_foto_merchant.type.includes(
            this.fotoMerchantFile.type.toLowerCase()
          );
        }
        return true;
      },
    },
    qrisFile: {
      validQRIS() {
        return true;
      },
    },
    nmid: {
      required() {
        if (this.isHaveQRIS == '1') {
          return this.nmid != '';
        }
        return true;
      },
      maxLength: maxLength(20),
      alphaNum,
    },
    sk: {
      required() {
        return this.sk;
      },
    },
    mid: {
      required,
      minLength: minLength(validations.mid.min_length),
      maxLength: maxLength(validations.mid.max_length),
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.mid == null ||
            this.errorValidation.mid.length < 1)
        );
      },
      numeric,

      forSticker() {
        return !(this.jenisQR == 1 && this.mid.substring(0, 1) != 6);
      },
    },
    tid: {},
  },
  data() {
    return {
      done: false,
      subStep: 1,
      sk: false,
      isLoadingKodepos: false,
      isLoadingJenisUsaha: false,
      isLoadingAreaCode: false,
      isLoadingApprovalId1: false,
      isLoadingApprovalId2: false,
      isloadingRekening: false,
      searchApprovalId1: '',
      searchApprovalId2: '',
      logoMerchant: null,
      listMerchantModel,
      listCriteria: dataListMerchantCriteria,
      listCriteriaCorporate: dataListMerchantCriteriaCorporate,
      listIDApprover: dataListIdApprover,
      listQrType: dataAllQrType,
      listUserRoles: dataUserRoles,
      merchantCriteria: null,
      kodepos: null,
      jenisUsaha: '',
      mdrOnUs: '',
      mdrOffUs: '',
      defaultMdrOnUs: '',
      defaultMdrOffUs: '',
      isSpecialMdr: false,
      mdrFile: null,
      areaCode: null,
      companyName: '',
      merchantName: '',
      merchantOwnerName: '',
      noKTP: '',
      noNPWP: '',
      merchantCriteriaValue: '',
      mccValue: '',
      noTelpMerchant: '',
      alamatMerchant: '',
      ktpFile: null,
      npwpFile: null,
      fotoMerchantFile: null,
      qrisFile: null,
      nmid: '',
      searchKodepos: '',
      searchJenisUsaha: '',
      searchAreaCode: '',
      allFile: [],
      isHaveQRIS: '0',
      validate: validations,
      ktpFileFocus: 0,
      npwpFileFocus: 0,
      fotoMerchantFileFocus: 0,
      IDApprover1: null,
      IDApprover2: null,
      mid: '',
      tid: '',
      callbackPartnerId: '',
      callbackPartnerClientSecret: '',
      callbackPartnerUrlToken: '',
      privateKeyPartner: '',
      endpointURL: '',
      ipAddress: '',
      noHandphoneMerchant: '',
      listQRType: dataQrType,
      listQRTypeIndividu: dataQrType,
      listTipeMerchant: dataTipeMerchantOnboarding,
      midMinLength: validations.mid.min_length,
      midMaxLength: validations.mid.max_length,
      tidMinLength: validations.tid.min_length,
      tidMaxLength: validations.tid.max_length,
      namaAggregator: '',
      criteriaQuote: null,
      rangeUbe: true,
      rangeUre: true,
      jenisUsahaQuote: '',
      midCron: null,
      individuQR: [],
      corporateQR: [],
      accountTypeParent: null,
      loadingAutofill: false,
      submerchantNotif: '0',
      isQrApi: false,
      delayHitServiceA1: null,
      delayHitServiceA2: null,
      showMDRForm: false,
      loadingMdr: false,
      rules: validationRules
    };
  },
  mounted() {
    this.getApprovalId1(this.listUserRoles[0].value);
    this.getApprovalId2(this.listUserRoles[1].value);
    this.getJenisUsaha();
    this.getAreaCode();
    this.email = this.$store.state.register.data.user.email;
    this.noHandphone = this.$store.state.register.data.user.mobilePhone;
    this.noHandphoneMerchant = this.$store.state.register.data.user.mobilePhone;
    if (this.isFromAggregator || this.isOutlet) {
      this.getDataAutofill();
    }
  },
  watch: {
    tipeMerchant: {
      handler() {
        this.jenisQR = '';
      },
    },
    isSpecialMdr: {
      handler(val) {
        if (!val) {
          this.mdrFile = null;
          this.$v.mdrFile.$reset();
          // Reset MDR values to default
          this.mdrOnUs = this.defaultMdrOnUs;
          this.mdrOffUs = this.defaultMdrOffUs;
        } else {
          this.$v.mdrFile.$touch();
        }
      },
    },
    jenisQR: {
      handler(val) {
        if (val == '2') {
          this.isQrApi = true;
        } else {
          this.isQrApi = false;
        }
        this.$store.commit('register/setSelectedInterfaces', []);
        this.$store.commit('register/setNeedInterface', false);

        if (this.defaultMdrOnUs && this.defaultMdrOffUs) {
          this.mdrOnUs = this.defaultMdrOnUs;
          this.mdrOffUs = this.defaultMdrOffUs;
        }

        this.isSpecialMdr = false;
        this.mdrFile = null;
        this.$v.mdrFile.$reset();
      },
    },
    qrisFile: {
      handler(val) {
        if (val != null) {
          this.checkQRIS();
        } else {
          this.nmid = '';
        }
      },
    },
    searchKodepos: {
      handler() {
        this.getDaerah();
      },
    },
    noRekening: {
      handler(val) {
        this.getValidateRek(val);

        if (this.errorValidation != null) {
          if (
            this.errorValidation.account_number != null &&
            val != this.errorValidation.account_number
          ) {
            this.$store.commit('register/clearErrorVariable', 'account_number');
          }
        }
      },
    },
    email: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.email != null &&
            val != this.errorValidation.email
          ) {
            this.$store.commit('register/clearErrorVariable', 'email');
          }
        }
      },
    },
    noHandphone: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.mobile_phone != null &&
            val != this.errorValidation.mobile_phone
          ) {
            this.$store.commit('register/clearErrorVariable', 'mobile_phone');
          }
        }
      },
    },
    noHandphoneMerchant: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.merchant_mobile_phone != null &&
            val != this.errorValidation.merchant_mobile_phone
          ) {
            this.$store.commit(
              'register/clearErrorVariable',
              'merchant_mobile_phone'
            );
          }
        }
      },
    },
    noKTP: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.ktp_no != null &&
            val != this.errorValidation.ktp_no
          ) {
            this.$store.commit('register/clearErrorVariable', 'ktp_no');
          }
        }
      },
    },
    noNPWP: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.npwp_no != null &&
            val != this.errorValidation.npwp_no
          ) {
            this.$store.commit('register/clearErrorVariable', 'npwp_no');
          }
        }
        if (this.isCorporate && val.length === 15 && !val.startsWith('0')) {
          this.noNPWP = `0${val}`;
        }
      },
      immediate: true,
    },
    mid: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.mid != null &&
            val != this.errorValidation.mid
          ) {
            this.$store.commit('register/clearErrorVariable', 'mid');
          }
        }
      },
    },
    tid: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.tid != null &&
            val != this.errorValidation.tid
          ) {
            this.$store.commit('register/clearErrorVariable', 'tid');
          }
        }
      },
    },
    kodepos: {
      immediate: true,
      handler(val) {
        /* if (this.namaKodepos) {
          this.getApprovalId1(this.listUserRoles[0].value);
          this.getApprovalId2(this.listUserRoles[1].value);
        } else {
          this.IDApprover1 = null;
          this.IDApprover2 = null;
          this.$store.commit('master/daerah/list/clearApproval');
        } */

        if (this.errorValidation != null) {
          if (
            this.errorValidation.postal_code != null &&
            val != this.errorValidation.postal_code
          ) {
            this.$store.commit('register/clearErrorVariable', 'postal_code');
          }
        }
      },
    },
    isHaveQRIS: {
      handler(val) {
        if (val == '0') {
          this.qrisFile = null;
          this.nmid = '';
        }
      },
    },
    mdrOnUs: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.mdr_on_us != null &&
            val != this.errorValidation.mdr_on_us
          ) {
            this.$store.commit('register/clearErrorVariable', 'mdr_on_us');
          }
        }
      },
    },
    mdrOffUs: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.mdr_off_us != null &&
            val != this.errorValidation.mdr_off_us
          ) {
            this.$store.commit('register/clearErrorVariable', 'mdr_off_us');
          }
        }
      },
    },
    callbackPartnerId: {
      handler() {
        if (this.errorValidation?.client_partner_id != null) {
          this.$store.commit('register/clearErrorVariable', 'client_partner_id');
        }
      },
    },
    callbackPartnerClientSecret: {
      handler() {
        if (this.errorValidation?.client_secret != null) {
          this.$store.commit('register/clearErrorVariable', 'client_secret');
        }
      },
    },
    privateKeyPartner: {
      handler() {
        if (this.errorValidation?.public_key_inbound != null) {
          this.$store.commit('register/clearErrorVariable', 'public_key_inbound');
        }
      },
    },
    jenisUsaha() {
      this.showMDR();
    },
    merchantCriteria() {
      this.merchantCriteriaValue = this.merchantCriteria.value;
      this.showMDR();
    },
    searchApprovalId1: {
      handler() {
        clearTimeout(this.delayHitServiceA1);
        // if (this.namaKodepos) {
        this.delayHitServiceA1 = setTimeout(() => {
          this.getApprovalId1(this.listUserRoles[0].value);
        }, dataDelayServiceHit);
        // }
      },
    },
    searchApprovalId2: {
      handler() {
        clearTimeout(this.delayHitServiceA2);
        // if (this.namaKodepos) {
        this.delayHitServiceA2 = setTimeout(() => {
          this.getApprovalId2(this.listUserRoles[1].value);
        }, dataDelayServiceHit);
        // }
      },
    },
    IDApprover1: {
      handler(val, oldVal) {
        if (val !== oldVal && this.errorValidation?.approver_1?.length > 0) {
          this.$store.commit('register/clearErrorVariable', 'approver_1');
        }
      },
      deep: true,
    },
    IDApprover2: {
      handler(val, oldVal) {
        if (val !== oldVal && this.errorValidation?.approver_2?.length > 0) {
          this.$store.commit('register/clearErrorVariable', 'approver_2');
        }
      },
      deep: true,
    },
    isCPTS: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal && this.showMDRForm && this.jenisUsaha && this.merchantCriteria) {
          this.getMDR();
        }
        this.$nextTick(() => {
          if (this.$v.mdrOnUs) {
            this.$v.mdrOnUs.$touch();
          }
          if (this.$v.mdrOffUs) {
            this.$v.mdrOffUs.$touch();
          }
        });
      },
    },
  },
  computed: {
    endpointURLErrors() {
      const errors = [];
      if (!this.$v.endpointURL.$dirty) return errors;
      if (!this.$v.endpointURL.required) errors.push('URL is required');
      if (!this.$v.endpointURL.validFormat) errors.push('URL must be a valid URL');
      return errors;
    },
    callbackPartnerIdErrors() {
      const errors = [];
      if (!this.$v.callbackPartnerId.$dirty) return errors;
      if (!this.$v.callbackPartnerId.required) errors.push('Callback Partner ID is required');
      if (!this.$v.callbackPartnerId.isUnique) {
        if (this.errorValidation?.client_partner_id != null) {
          this.errorValidation.client_partner_id.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    callbackPartnerClientSecretErrors() {
      const errors = [];
      if (!this.$v.callbackPartnerClientSecret.$dirty) return errors;
      if (!this.$v.callbackPartnerClientSecret.required) errors.push('Callback Partner Client Secret is required');
      if (!this.$v.callbackPartnerClientSecret.isUnique) {
        if (this.errorValidation?.client_secret != null) {
          this.errorValidation.client_secret.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    callbackPartnerUrlTokenErrors() {
      const errors = [];
      if (!this.$v.callbackPartnerUrlToken.$dirty) return errors;
      if (!this.$v.callbackPartnerUrlToken.required) errors.push('Callback Partner URL Token is required');
      if (!this.$v.callbackPartnerUrlToken.validFormat) errors.push('Callback Partner URL Token must be a valid URL');
      return errors;
    },
    beCallbackPartnerIdErrors() {
      if (this.errorValidation?.client_partner_id != null) {
        return this.errorValidation.client_partner_id;
      }
      return [];
    },
    beCallbackPartnerClientSecretErrors() {
      if (this.errorValidation?.client_secret != null) {
        return this.errorValidation.client_secret;
      }
      return [];
    },
    privateKeyPartnerErrors() {
      const errors = [];
      if (!this.$v.privateKeyPartner.$dirty) return errors;
      if (!this.$v.privateKeyPartner.required) errors.push('Public Key Partner is required');
      if (!this.$v.privateKeyPartner.validFormat) errors.push('Invalid Public Partner Key format');
      if (!this.$v.privateKeyPartner.isUnique) {
        if (this.errorValidation?.public_key_inbound != null) {
          this.errorValidation.public_key_inbound.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    isAPI() {
      return this.$store.state.register.data.qrType == 2;
    },
    isVersionSnap(){
      return this.$store.state.register.data.clientVersion == 2;
    },
    accessTokenEndpoint() {
      return this.$store.state.register.data.accessTokenEndpoint;
    },
    qrVersionText() {
      const client = this.$store.state.register.data.clientVersion;
      const clientInfo = clientType.find(item => item.value === client);
      return clientInfo ? clientInfo.text : '';
    },
    isCPTS() {
      const { qrTypeInterface } = this.$store.state.register.data;
      return Array.isArray(qrTypeInterface) && qrTypeInterface.includes('cpts');
    },
    errorValidation() {
      return this.$store.state.register.errors;
    },
    /**
     * Whether the last submission was rejected because of specific fields.
     *
     * Only a field-level rejection warrants sending the user back to a previous
     * sub step and scrolling to an input. A denied permission, an expired
     * session or a server fault leaves every field valid, so moving the user
     * would send them hunting for an error that is not there.
     *
     * @returns {boolean} True when at least one field carries an error.
     */
    hasFieldErrors() {
      const errors = this.errorValidation;
      if (errors == null || typeof errors !== 'object') return false;

      return Object.keys(errors).some(
        (field) => (errors[field] || []).length > 0
      );
    },
    invalidQRIS() {
      return this.$store.state.register.qrisError;
    },
    isOutlet() {
      return (
        this.$route.params.id != undefined &&
        this.$route.params.idAggregator == undefined
      );
    },
    isFromAggregator() {
      return this.$route.params.idAggregator != undefined;
    },
    fieldInfoType() {
      if (this.isOutlet) return 'outletMerchant';
      if (this.isFromAggregator && this.$route.params.id) return 'outletSubmerchant';
      return 'submerchant';
    },
    isIncludeAPI() {
      const apiQRTypes = ['2', '4', '5', '7'];
      return apiQRTypes.includes(String(this.jenisQR));
    },
    qrItemsFiltered() {
      return this.tipeMerchant == '1' ? this.individuQR : this.corporateQR;
    },
    qrItems() {
      return this.tipeMerchant == '1'
        ? this.listQRTypeIndividu
        : this.listQRType;
    },
    tipeMerchantText() {
      return this.tipeMerchant == '1' ? 'Individu' : 'Badan Usaha';
    },
    itemsApprovalId1() {
      const list = this.$store.state.master.daerah.list.approvalId1.find(
        (a) =>
          a.user_id ==
          JSON.parse(localStorage.getItem('logged_in_qram')).user.id
      );
      return list != undefined
        ? [list]
        : this.$store.state.master.daerah.list.approvalId1;
    },
    itemsApprovalId2() {
      return this.$store.state.master.daerah.list.approvalId2;
    },
    OnValidateQRIS() {
      return this.$store.state.register.OnValidateQRIS;
    },
    isCorporate() {
      return this.$store.state.register.data.accountType == '2';
    },
    noRekening: {
      set(val) {
        this.$store.commit('register/setNoRekening', val);
      },
      get() {
        return this.$store.state.register.data.noRekening;
      },
    },
    email: {
      get() {
        return this.$store.state.register.data.user.email;
      },
      set(val) {
        this.$store.commit('register/setEmailUser', val);
      },
    },
    noHandphone: {
      get() {
        return this.$store.state.register.data.user.mobilePhone;
      },
      set(val) {
        this.$store.commit('register/setNoHandphoneUser', val);
      },
    },
    tipeMerchant: {
      get() {
        return this.$store.state.register.data.accountType;
      },
      set(val) {
        this.$store.commit('register/setAccountType', val);
      },
    },
    jenisQR: {
      get() {
        return this.$store.state.register.data.qrType;
      },
      set(val) {
        this.$store.commit('register/setQrType', val);
      },
    },

    mcc: {
      get() {
        return this.$store.state.register.data.qrType;
      },
      set(val) {
        this.$store.commit('register/setQrType', val);
      },
    },
    merchantModel: {
      get() {
        return this.$store.state.register.data.merchantModel;
      },
      set(val) {
        this.$store.commit('register/setMerchantModel', val);
      },
    },
    merchantPhone() {
      const area = this.areaCode != null ? `(${this.areaCode})` : '';
      const phone = this.noTelpMerchant != '' ? this.noTelpMerchant : '';
      return `${area} ${phone}`;
    },
    tipeMerchantErrors() {
      const errors = [];
      if (!this.$v.tipeMerchant.$dirty) return errors;
      if (!this.$v.tipeMerchant.required) {
        errors.push('Tipe Merchant is required');
      }
      return errors;
    },
    jenisQRErrors() {
      const errors = [];
      if (!this.$v.jenisQR.$dirty) return errors;
      if (!this.$v.jenisQR.required) errors.push('Jenis QR is required');
      return errors;
    },
    merchantModelErrors() {
      const errors = [];
      if (!this.$v.merchantModel.$dirty) return errors;
      if (!this.$v.merchantModel.required) errors.push('Model Usaha is required');
      return errors;
    },
    noRekeningErrors() {
      const errors = [];
      if (!this.$v.noRekening.$dirty) return errors;
      if (!this.$v.noRekening.required) {
        errors.push('Nomor Rekening is required');
      }
      if (!this.$v.noRekening.numeric) errors.push('Must be numeric');
      if (!this.$v.noRekening.isRekVc) errors.push('Must be 9-10 or 16 digits');
      if (!this.$v.noRekening.isUnique) {
        if (this.errorValidation.account_number != null) {
          this.errorValidation.account_number.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },

    kodeposErrors() {
      const errors = [];
      if (!this.$v.kodepos.$dirty) return errors;
      if (!this.$v.kodepos.required) errors.push('Kode Pos is required');
      if (!this.$v.kodepos.isRegistered) {
        if (this.errorValidation.postal_code != null) {
          this.errorValidation.postal_code.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    jenisUsahaErrors() {
      const errors = [];
      if (!this.$v.jenisUsaha.$dirty) return errors;

      if (this.$v.jenisUsaha.$model != null) {
        const mccNot = this.$v.jenisUsaha.$model.mcc;
        const notApply = this.notApply(mccNot);
        if (!notApply) {
          if (!this.$v.jenisUsaha.jenisUsahaChange)
            errors.push(
              `Jenis Usaha ${this.$v.jenisUsaha.$model.description.toLowerCase()} does not apply`
            );
        }
      }

      if (!this.$v.jenisUsaha.required) errors.push('Jenis Usaha is required');
      return errors;
    },
    mdrOnUsErrors() {
      const errors = [];
      if (!this.$v.mdrOnUs.$dirty) return errors;
      if (!this.$v.mdrOnUs.required) errors.push('MDR On Us is required!');
      if (!this.$v.mdrOnUs.numericDecimal) {
        errors.push('MDR On Us is numeric only');
      }
      if (!this.$v.mdrOnUs.minVal) {
        errors.push(`Minimal value is ${process.env.VUE_APP_MIN_MDR}!`);
      }
      if (!this.$v.mdrOnUs.maxVal) {
        let maxValue = process.env.VUE_APP_MAX_MDR;
        if (this.isCPTS) {
          const isMerchant = this.tipeMerchant === '1' && !this.isFromAggregator;
          maxValue = isMerchant
            ? dataCptsMdrValues.merchant.mdr_on_us 
            : dataCptsMdrValues.sub_merchant.mdr_on_us;
        }
        errors.push(`Maximal value is ${maxValue}!`);
      }
      if (!this.$v.mdrOnUs.isValidMdr) {
        if (this.errorValidation.mdr_on_us != null) {
          this.errorValidation.mdr_on_us.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    mdrOffUsErrors() {
      const errors = [];
      if (!this.$v.mdrOffUs.$dirty) return errors;
      if (!this.$v.mdrOffUs.required) errors.push('MDR Off Us is required!');
      if (!this.$v.mdrOffUs.numericDecimal) {
        errors.push('MDR Off Us is numeric only');
      }
      if (!this.$v.mdrOffUs.minVal) {
        errors.push(`Minimal value is ${process.env.VUE_APP_MIN_MDR}!`);
      }
      if (!this.$v.mdrOffUs.maxVal) {
        let maxValue = process.env.VUE_APP_MAX_MDR;
        if (this.isCPTS) {
          const isMerchant = this.tipeMerchant === '1' && !this.isFromAggregator;
          maxValue = isMerchant
            ? dataCptsMdrValues.merchant.mdr_off_us 
            : dataCptsMdrValues.sub_merchant.mdr_off_us;
        }
        errors.push(`Maximal value is ${maxValue}!`);
      }
      if (!this.$v.mdrOffUs.isValidMdr) {
        if (this.errorValidation.mdr_off_us != null) {
          this.errorValidation.mdr_off_us.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    mdrFileErrors() {
      const errors = [];
      if (!this.$v.mdrFile.$dirty) return errors;
      if (!this.$v.mdrFile.required) errors.push('Dokumen MDR Khusus is Required!');
      if (!this.$v.mdrFile.maxSize) {
        errors.push('File MDR max size is 1MB');
      }
      if (!this.$v.mdrFile.fileType) {
        errors.push('File MDR must be PDF format');
      }
      return errors;
    },
    merchantCriteriaErrors() {
      const errors = [];

      const checkIsNotUbe = () => {
        const modelMcc = this.$v.jenisUsaha.$model?.mcc;
        const rangeMccQuote = this.rangeQuote(modelMcc);

        if (!rangeMccQuote && !this.$v.merchantCriteria.criteriaRange) {
          errors.push(
            'Kode jenis usaha 3500 sampai 3828 - merchant criteria mandatory for (UBE) Usaha Besar'
          );
        }
      };

      const checkIsUbe = () => {
        const modelMcc = this.merchantCriteriaValue;
        this.rangeQuote(modelMcc);
      };

      const checkIsNotUre = () => {
        const quoteMcc = this.$v.jenisUsaha.$model?.mcc;
        const quoteCriteria = this.rangeQuoteUre(quoteMcc);

        if (!quoteCriteria && !this.$v.merchantCriteria.criteriaUre) {
          errors.push('Merchant criteria mandatory for (URE) Usaha Reguler');
        }
      };

      const checkIsUre = () => {
        const modelMcc = this.merchantCriteriaValue;
        this.rangeQuoteUre(modelMcc);
      };

      const isUbe = this.merchantCriteriaValue === 'UBE';
      const isUre = this.merchantCriteriaValue === 'URE';

      if (!isUbe && this.$v.jenisUsaha.$model) {
        checkIsNotUbe();
      } else if (isUbe) {
        checkIsUbe();
      }

      if (!isUre && this.$v.jenisUsaha.$model) {
        checkIsNotUre();
      } else if (isUre) {
        checkIsUre();
      }

      if (
        this.$v.merchantCriteria.$dirty &&
        !this.$v.merchantCriteria.required
      ) {
        errors.push('Merchant Criteria is required');
      }

      return errors;
    },
    companyNameErrors() {
      const errors = [];
      if (!this.$v.companyName.$dirty) return errors;
      if (!this.$v.companyName.required) {
        errors.push('Nama Perusahaan is required');
      }
      if (!this.$v.companyName.maxLength) {
        errors.push(
          `Company name can't more than ${dataVarcharMaxLength} character`
        );
      }
      if (!this.$v.companyName.alphanumChar)
        errors.push(`Valid character are A-z, 0-9, and (*)`);
      return errors;
    },
    typeMerchant() {
      return this.isFromAggregator ? 'Sub Merchant' : 'Merchant';
    },
    merchantNameErrors() {
      const errors = [];
      const csLewisMerchant = this.merchantName?.toLowerCase();
      const criteriaRegex = [
        /spbu/,
        /pertamina/,
        /pertamini/,
        /petrolium/,
        /gas/,
        /spbg/,
        /spba/,
      ];
      const garudaRegex = [/garuda/];

      const isRequiredSpbu = [5541, 5542, 5172, 5983].includes(
        parseInt(this.jenisUsaha?.mcc, 10)
      );
      const isRequiredGaruda = parseInt(this.jenisUsaha?.mcc, 10) === 3103;

      const criteriaError = this.checkCriteria(
        csLewisMerchant,
        criteriaRegex,
        `Nama ${this.typeMerchant} harus mengandung salah satu dari: SPBU, SPBA, SPBG, Pertamina, Pertamini, Petrolium, Gas`,
        isRequiredSpbu
      );

      const garudaError = this.checkCriteria(
        csLewisMerchant,
        garudaRegex,
        `Nama ${this.typeMerchant} harus mengandung kata: Garuda`,
        isRequiredGaruda
      );

      const alphanumericError = this.checkAlphanumeric();
      const numberValidationError = this.checkNumberValidate();
      const maxLengthError = this.checkMaxLength();
      const requiredError = this.checkRequired();

      if (criteriaError) errors.push(criteriaError);
      if (garudaError) errors.push(garudaError);
      if (alphanumericError) errors.push(alphanumericError);
      if (numberValidationError) errors.push(numberValidationError);
      if (maxLengthError) errors.push(maxLengthError);
      if (requiredError) errors.push(requiredError);

      return errors;
    },

    merchantOwnerNameErrors() {
      const errors = [];
      if (!this.$v.merchantOwnerName.$dirty) return errors;
      if (!this.$v.merchantOwnerName.required) {
        errors.push('Nama Pemilik Usaha is required');
      }
      if (!this.$v.merchantOwnerName.maxLength) {
        errors.push(
          `Merchant owner name can't more than ${dataVarcharMaxLength} character`
        );
      }
      if (!this.$v.merchantOwnerName.alphanumChar)
        errors.push(`Valid character are A-z, 0-9, and (*)`);
      return errors;
    },
    noTelpMerchantErrors() {
      const errors = [];
      if (!this.$v.noTelpMerchant.$dirty) return errors;
      if (!this.$v.noTelpMerchant.numeric) errors.push('Must be numeric');
      if (!this.$v.noTelpMerchant.maxLength) {
        errors.push('Telephone number max length is 15 digit');
      }
      return errors;
    },
    noKTPErrors() {
      const errors = [];
      if (!this.$v.noKTP.$dirty) return errors;
      if (!this.$v.noKTP.required) errors.push('KTP number is required');
      if (!this.$v.noKTP.numeric) errors.push('Must be numeric');
      if (!this.$v.noKTP.maxLength) errors.push('KTP number must be 16 digit');
      if (!this.$v.noKTP.minLength) errors.push('KTP number must be 16 digit');
      if (!this.$v.noKTP.isUnique) {
        if (this.errorValidation.ktp_no != null) {
          this.errorValidation.ktp_no.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    noNPWPErrors() {
      const errors = [];
      if (!this.$v.noNPWP.$dirty) return errors;
      if (!this.$v.noNPWP.required) errors.push('NPWP number is required');
      if (!this.$v.noNPWP.numeric) errors.push('Must be numeric');
      if (!this.$v.noNPWP.maxLength) {
        errors.push('NPWP harus 16 digit, pastikan Anda mengisi data dengan benar!');
      }
      if (!this.$v.noNPWP.minLength) {
        errors.push('NPWP harus 16 digit, pastikan Anda mengisi data dengan benar!');
      }
      if (!this.$v.noNPWP.isUnique) {
        if (this.errorValidation.npwp_no != null) {
          this.errorValidation.npwp_no.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },


    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.email || !this.$v.email.doesNotContainPipe)
        errors.push('Must be valid e-mail');
      if (!this.$v.email.required) errors.push('Email is required');
      if (!this.$v.email.isUnique) {
        if (this.errorValidation.email != null) {
          this.errorValidation.email.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    noHandphoneErrors() {
      const errors = [];
      if (!this.$v.noHandphone.$dirty) return errors;
      if (!this.$v.noHandphone.required) {
        errors.push('No Handphone is required');
      }
      if (!this.$v.noHandphone.maxLength) {
        errors.push('No Handphone max length is 15 digit');
      }
      if (!this.$v.noHandphone.numeric) errors.push('Must be numeric');
      if (!this.$v.noHandphone.isUnique) {
        if (this.errorValidation.mobile_phone != null) {
          this.errorValidation.mobile_phone.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },

    noHandphoneMerchantErrors() {
      const errors = [];
      if (!this.$v.noHandphoneMerchant.$dirty) return errors;
      if (!this.$v.noHandphoneMerchant.required) {
        errors.push('No Handphone Merchant is required');
      }
      if (!this.$v.noHandphoneMerchant.maxLength) {
        errors.push('No Handphone Merchant max length is 15 digit');
      }
      if (!this.$v.noHandphoneMerchant.numeric) errors.push('Must be numeric');
      if (!this.$v.noHandphoneMerchant.isUnique) {
        if (this.errorValidation.merchant_mobile_phone != null) {
          this.errorValidation.merchant_mobile_phone.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    ipAddressErrors() {
      const errors = [];
      if (!this.$v.ipAddress.$dirty) return errors;
      if (!this.$v.ipAddress.ipAddress) {
        errors.push('Must be a valid ip address');
      }
      if (!this.$v.ipAddress.maxLength) {
        errors.push(
          `IP Address can't more than ${dataVarcharMaxLength} character`
        );
      }
      return errors;
    },
    IDApprover1Errors() {
      const errors = [];
      if (!this.$v.IDApprover1.$dirty) return errors;
      if (!this.$v.IDApprover1.required) {
        errors.push('ID Approver 1 is required');
      }
      if (!this.$v.IDApprover1.isUnique) {
        if (this.errorValidation.approver_1 != null) {
          this.errorValidation.approver_1.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    IDApprover2Errors() {
      const errors = [];
      if (!this.$v.IDApprover2.$dirty) return errors;
      if (!this.$v.IDApprover2.required) {
        errors.push('ID Approver 2 is required');
      }
      if (!this.$v.IDApprover2.isUnique) {
        if (this.errorValidation.approver_2 != null) {
          this.errorValidation.approver_2.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    midErrors() {
      const errors = [];
      if (!this.$v.mid.$dirty) return errors;
      if (!this.$v.mid.required) errors.push('MID is required');
      if (!this.$v.mid.minLength) {
        errors.push(`MID must be at least ${this.midMinLength} digit`);
      }
      if (!this.$v.mid.maxLength) {
        errors.push(`MID can't more than ${this.midMaxLength} digit`);
      }
      if (!this.$v.mid.numeric) errors.push('Must be numeric');
      if (!this.$v.mid.forSticker) errors.push('QR Sticker, prefix wajib 6');
      if (!this.$v.mid.isUnique) {
        if (this.errorValidation.mid != null) {
          this.errorValidation.mid.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    tidErrors() {
      const errors = [];
      return errors;
    },
    alamatMerchantErrors() {
      const errors = [];
      if (!this.$v.alamatMerchant.$dirty) return errors;
      if (!this.$v.alamatMerchant.required) {
        errors.push('Alamat Merchant is required');
      }
      if (!this.$v.alamatMerchant.maxLength) {
        errors.push(
          `Alamat merchant can't more than ${dataVarcharMaxLength} character`
        );
      }
      if (!this.$v.alamatMerchant.doesNotContainPipe)
        errors.push(`Character is not allowed`);
      return errors;
    },
    ktpFileErrors() {
      const errors = [];
      if (!this.$v.ktpFile.$dirty) return errors;
      if (!this.$v.ktpFile.required) errors.push('File KTP is required');
      if (!this.$v.ktpFile.maxSize) {
        errors.push(
          `File KTP max size is ${this.validate.file_ktp.max.toString()}kb`
        );
      }
      if (!this.$v.ktpFile.fileType) errors.push('Incorrect filetype KTP File');
      return errors;
    },
    npwpFileErrors() {
      const errors = [];
      if (!this.$v.npwpFile.$dirty) return errors;
      if (!this.$v.npwpFile.required) errors.push('File NPWP is required');
      if (!this.$v.npwpFile.maxSize) {
        errors.push(
          `File NPWP max size is ${this.validate.file_npwp.max.toString()}kb`
        );
      }
      if (!this.$v.npwpFile.fileType) {
        errors.push('Incorrect filetype NPWP File');
      }
      return errors;
    },
    qrisFileErrors() {
      const errors = [];
      if (!this.$v.qrisFile.$dirty) return errors;
      if (!this.$v.qrisFile.validQRIS) errors.push('QRIS File not valid!');
      if (!this.$v.qrisFile.maxSize) {
        errors.push(
          `File QRIS max size is ${this.validate.file_qris.max.toString()}kb`
        );
      }
      if (!this.$v.qrisFile.fileType) {
        errors.push('Incorrect filetype QRIS File');
      }
      return errors;
    },
    nmidErrors() {
      const errors = [];
      if (!this.$v.nmid.$dirty) return errors;
      if (!this.$v.nmid.required) errors.push('NMID required!');
      if (!this.$v.nmid.maxLength) {
        errors.push('NMID maximum length is 20 digit !');
      }
      if (!this.$v.nmid.alphaNum) errors.push('NMID must be alphanumeric!');
      return errors;
    },
    fotoMerchantFileErrors() {
      const errors = [];
      if (!this.$v.fotoMerchantFile.$dirty) return errors;
      if (!this.$v.fotoMerchantFile.required) {
        errors.push('File Foto Merchant is required');
      }
      if (!this.$v.fotoMerchantFile.maxSize) {
        errors.push(
          `File Foto Merchant max size is ${this.validate.file_foto_merchant.max.toString()}kb`
        );
      }
      if (!this.$v.fotoMerchantFile.fileType) {
        errors.push('Incorrect filetype Foto Merchant File');
      }
      return errors;
    },
    skErrors() {
      const errors = [];
      if (!this.$v.sk.$dirty) return errors;
      if (!this.$v.sk.required) errors.push('S&K is required');
      return errors;
    },
    uploadProgress() {
      return this.$store.state.register.uploadProgress;
    },
    uploadName() {
      return this.$store.state.register.uploadName;
    },
    onUpload() {
      return this.$store.state.register.onUpload;
    },
    itemsKodepos() {
      return this.$store.state.master.daerah.list.kodepos;
    },
    itemsJenisUsaha() {
      return this.$store.state.master.daerah.list.jenisUsaha;
    },
    itemsAreaCode() {
      return this.$store.state.master.daerah.list.areaCode;
    },
    bckoPreviewText() {
      if (!this.bcko) {
        return '( not set )';
      }
      return `${this.bcko.branch_code_bcko || ''} - ${this.bcko.outlet_name || ''}`;
    },
    cmerPreviewText() {
      if (!this.cmer) {
        return '( not set )';
      }
      return `${this.cmer.code || ''} - ${this.cmer.definition || ''}`;
    },
    namaJenisUsaha() {
      return this.jenisUsaha == null ? '' : this.jenisUsaha.mcc_name;
    },
    namaCriteriaMerchant() {
      return this.merchantCriteria == null ? '' : this.merchantCriteria.text;
    },
    namaProvinsi() {
      return this.getNamaDaerah('provinsi');
    },
    namaKabupaten() {
      return this.getNamaDaerah('kabupaten');
    },
    namaKecamatan() {
      return this.getNamaDaerah('kecamatan');
    },
    namaKelurahan() {
      return this.getNamaDaerah('kelurahan');
    },
    namaKodepos() {
      return this.getNamaDaerah('kodepos');
    },
    pdfFileSK() {
      return `${window.location.origin}/assets/pdf/SK_Merchant_QRIS.pdf`;
    },
    qrTypeText() {
      const type = this.listQrType.find(
        (x) => x.value == this.$store.state.register.data.qrType
      );
      const cpts = this.isCPTS ? 'CPTS' : '';
      return type != undefined ? type.text : cpts;
    },
    previewKtpFile() {
      return this.ktpFile == null ? '' : URL.createObjectURL(this.ktpFile);
    },
    previewNpwpFile() {
      return this.npwpFile == null ? '' : URL.createObjectURL(this.npwpFile);
    },
    previewFotoMerchantFile() {
      return this.fotoMerchantFile == null
        ? ''
        : URL.createObjectURL(this.fotoMerchantFile);
    },
    previewQrisFile() {
      return this.qrisFile == null ? '' : URL.createObjectURL(this.qrisFile);
    },
    previewLogoMerchant() {
      return this.logoMerchant == null
        ? null
        : URL.createObjectURL(this.logoMerchant);
    },
    validateStep2() {
      return !(
        this.$v.ktpFile.$error ||
        this.$v.npwpFile.$error ||
        this.$v.fotoMerchantFile.$error ||
        this.$v.qrisFile.$error ||
        this.$v.nmid.$error
      );
    },
    validateStep1() {
      const hasAggregatorInterfaceError = (this.isFromAggregator || this.isOutlet) && this.isIncludeAPI && this.$refs.aggregatorInterfaceField
        ? this.$refs.aggregatorInterfaceField.$v.selectedInterfaces.$error
        : false;
      const hasQrChannelError = this.$refs.qrChannelField
        ? this.$refs.qrChannelField.$v.selectedChannel.$error
        : false;
      const hasMdrFileError = this.isSpecialMdr ? this.$v.mdrFile.$error : false;
      return !(
        this.$v.noRekening.$error ||
        this.$v.kodepos.$error ||
        this.$v.jenisUsaha.$error ||
        this.$v.mdrOnUs.$error ||
        this.$v.mdrOffUs.$error ||
        hasMdrFileError ||
        this.$v.merchantModel.$error ||
        this.$v.merchantCriteria.$error ||
        this.$v.companyName.$error ||
        this.$v.merchantName.$error ||
        this.$v.merchantOwnerName.$error ||
        this.$v.noKTP.$error ||
        this.$v.noNPWP.$error ||
        this.$v.email.$error ||
        this.$v.noHandphone.$error ||
        this.$v.noHandphoneMerchant.$error ||
        this.$v.alamatMerchant.$error ||
        this.$v.bcko.$error ||
        this.$v.cmer.$error ||
        this.$v.rmReferalCode.$error ||
        this.$v.noTelpMerchant.$error ||
        this.$v.IDApprover1.$error ||
        this.$v.IDApprover2.$error ||
        this.$v.endpointURL.$error ||
        (this.isAPI && this.isVersionSnap && (
          this.$v.callbackPartnerId.$error ||
          this.$v.callbackPartnerClientSecret.$error ||
          this.$v.callbackPartnerUrlToken.$error ||
          this.$v.privateKeyPartner.$error
        )) ||
      (this.isAPI && this.$v.endpointURL.$error) ||
      hasAggregatorInterfaceError ||
      hasQrChannelError
      );
    },
    validateStep3() {
      return !(this.$v.sk.$error || this.$v.mid.$error);
    },
    isLoading() {
      return this.$store.state.register.loading;
    },
    channelQr() {
      return this.areaCode || '';
    },
    channelQrObject() {
      const {channelCode} = this.$store.state.register.data;
      if (!channelCode) return null;
      const channelItem = this.$store.state.register.channelQrList.find(item => item.code === channelCode);
      return channelItem || { code: channelCode, desc: '' };
    },
  },
  methods: {
    checkCriteria(csLewisMerchant, regex, errorMessage, isRequired) {
      if (
        this.jenisUsaha &&
        isRequired &&
        !this.matchInArray(csLewisMerchant, regex) &&
        !this.$v.merchantName.merchantCriteriaMcc
      ) {
        return errorMessage;
      }
      return null;
    },
    checkAlphanumeric() {
      if (this.merchantName && !this.$v.merchantName.alphanumChar) {
        return `Valid character are A-z, 0-9, and (*)`;
      }
      return null;
    },
    checkNumberValidate() {
      if (this.merchantName && !this.$v.merchantName.numberValidate) {
        return `Nama ${this.typeMerchant} cannot be all numbers`;
      }
      return null;
    },
    checkMaxLength() {
      if (
        !this.isFromAggregator &&
        this.merchantName &&
        !this.$v.merchantName.maxLength
      ) {
        return `Nama ${this.typeMerchant} can't be more than ${dataVarcharMaxLength} characters`;
      }
      return null;
    },
    checkRequired() {
      if (this.$v.merchantName.$dirty && !this.$v.merchantName.required) {
        return `Nama ${this.typeMerchant} is required`;
      }
      return null;
    },
    showMDR() {
      this.mdrOnUs = '';
      this.mdrOffUs = '';
      if (
        this.jenisUsaha != null &&
        this.jenisUsaha.mcc != '' &&
        this.merchantCriteria
      ) {
        this.showMDRForm = true;
        this.getMDR();
      } else {
        this.showMDRForm = false;
      }
    },

    matchInArray(csLewisMerhant = null, regexQuote = null) {
      if (csLewisMerhant && regexQuote != null) {
        const len = regexQuote.length;
        for (let i = 0; i < len; i += 1) {
          if (csLewisMerhant.match(regexQuote[i])) {
            this.criteriaQuote = true;
            return true;
          }
        }
        this.criteriaQuote = false;
        return false;
      }
      this.criteriaQuote = true;
      return true;
    },

    notApply(mccNot) {
      if (mccNot == 5598 || mccNot == 2222) {
        this.jenisUsahaQuote = false;
        this.criteriaQuote = true;
        return false;
      }
      this.criteriaQuote = true;
      this.jenisUsahaQuote = true;
      return true;
    },

    rangeQuote(mccCriteria) {
      if (mccCriteria == 'UBE') {
        this.rangeUbe = true;
        return true;
      }
      if (mccCriteria >= 3500 && mccCriteria <= 3828) {
        this.rangeUbe = false;
        return false;
      }
      this.rangeUbe = true;
      return true;
    },

    rangeQuoteUre(mccCriteria) {
      if (mccCriteria == 'URE') {
        this.rangeUre = true;
        return true;
      }
      if (mccCriteria == 8661 || mccCriteria == 8398) {
        this.rangeUre = false;
        return false;
      }
      this.rangeUre = true;
      return true;
    },

    getMDR() {
      this.loadingMdr = true;
      
      if (this.isCPTS) {
        const isMerchant = this.tipeMerchant === '1' && !this.isFromAggregator;
        const mdrValues = isMerchant
          ? dataCptsMdrValues.merchant 
          : dataCptsMdrValues.sub_merchant;
        
        this.mdrOnUs = mdrValues.mdr_on_us.toString();
        this.mdrOffUs = mdrValues.mdr_off_us.toString();

        this.defaultMdrOnUs = this.mdrOnUs;
        this.defaultMdrOffUs = this.mdrOffUs;
        this.loadingMdr = false;
        return;
      }
      
      this.$store
        .dispatch('register/getMdrList', {
          mcc: this.jenisUsaha.mcc,
          merchant_criteria: this.merchantCriteria.value,
          date,
        })
        .then((res) => {
          if (res) {
            this.mdrOnUs = res.mdr_on_us;
            this.mdrOffUs = res.mdr_off_us;

            this.defaultMdrOnUs = this.mdrOnUs;
            this.defaultMdrOffUs = this.mdrOffUs;
          }
        })
        .finally(() => {
          this.loadingMdr = false;
        });
    },
    customFilter(item, queryText) {
      const textOne = item.mcc_name.toLowerCase();
      const textTwo = item.mcc.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },

    getDataAutofill() {
      this.loadingAutofill = true;
      this.$store
        .dispatch('register/getDataAutofill', {
          date,
          id_merchant: this.$route.params.id ?? '',
          id_aggregator:
            this.$route.params.idAggregator == undefined
              ? ''
              : this.$route.params.idAggregator,
        })
        .then((res) => {
          this.getDetailDataAutofill(res);
        })
        .finally(() => {
          this.loadingAutofill = false;
        });
    },

    getDetailDataAutofill(res) {
      if (res?.merchant) {
        this.getDetailDataAutofillMerchant(res);
      }
      if (res?.aggregator) {
        this.getDetailDataAutofillAggre(res);
      }
    },
    getDetailDataAutofillMerchant(res) {
      this.noKTP = res.merchant.ktp_no;
      this.email = res.merchant.email;
      this.noHandphone = res.merchant.mobile_phone;
      this.accountTypeParent = res.merchant.account_type;
      this.tipeMerchant =
        res.merchant.account_type == null
          ? ''
          : res.merchant.account_type.toString();
    },
    getDetailDataAutofillAggre(res) {
      this.namaAggregator = res.aggregator.aggregator_name;
      this.ipAddress = res.aggregator.ip_address;
      this.endpointURL = res.aggregator.endpoint;
      const filteredQR = qrByMerchantType(
        res.aggregator.qr_type == null ? '' : res.aggregator.qr_type.toString()
      );
      this.individuQR = filteredQR.individu;
      this.corporateQR = filteredQR.corporate;
      if (filteredQR.individu.length == 0) {
        this.tipeMerchant = '2';
      }
      this.submerchantNotif =
        res.aggregator.notif_sticker_status == null
          ? '0'
          : res.aggregator.notif_sticker_status.toString();
    },

    getNamaDaerah(category) {
      if (this.kodepos != null) {
        let nama = '';
        const splitDaerah = this.kodepos.id.split(', ');
        const [kelurahan, kecamatan, kabupaten, provinsi, kodepos] =
          splitDaerah;

        switch (category) {
          case 'kodepos':
            nama = kodepos;
            break;
          case 'provinsi':
            nama = provinsi;
            break;
          case 'kabupaten':
            nama = kabupaten;
            break;
          case 'kecamatan':
            nama = kecamatan;
            break;
          case 'kelurahan':
            nama = kelurahan;
            break;
          default:
            break;
        }
        return nama;
      }
      return '';
    },

    copyNoKTPtoNPWP() {
      this.noNPWP = this.noKTP;
    },

    setLogoMerchant(e) {
      const [file] = e.target.files || e.dataTransfer.files;

      if (!file) {
        this.logoMerchant = null;
        return;
      }

      this.logoMerchant = file;
    },
    async getDaerah() {
      this.isLoadingKodepos = true;
      await this.$store.dispatch('master/daerah/list/getDaerah', {
        query: this.searchKodepos == null ? '' : this.searchKodepos,
      });
      this.isLoadingKodepos = false;
    },

    async getApprovalId1(role) {
      this.isLoadingApprovalId1 = true;
      await this.$store
        .dispatch('master/daerah/list/getApprovalId1', {
          date,
          role,
          kodepos: this.namaKodepos,
          search: {
            username: this.searchApprovalId1,
          },
        })
        .finally(() => {
          this.isLoadingApprovalId1 = false;
        });
    },

    async getApprovalId2(role) {
      this.isLoadingApprovalId2 = true;
      await this.$store
        .dispatch('master/daerah/list/getApprovalId2', {
          date,
          role,
          kodepos: this.namaKodepos,
          search: {
            username: this.searchApprovalId2,
          },
        })
        .finally(() => {
          this.isLoadingApprovalId2 = false;
        });
    },

    async getJenisUsaha() {
      this.isLoadingJenisUsaha = true;
      await this.$store.dispatch('master/daerah/list/getJenisUsaha', {
        date,
        searchName: this.searchJenisUsaha,
      });
      this.isLoadingJenisUsaha = false;
    },

    async getAreaCode() {
      this.isLoadingAreaCode = true;
      await this.$store.dispatch('master/daerah/list/getAreaCode', {
        date,
        query: this.searchAreaCode,
      });
      this.isLoadingAreaCode = false;
    },


    async getValidateRek(val) {
      this.isloadingRekening = true;
      this.$store
        .dispatch('register/validate', {
          date,
          no_rekening: val,
        })
        .then(() => {
          this.isloadingRekening = false;
        });
    },

    touchStep1() {
      this.$v.jenisQR.$touch();
      this.$v.tipeMerchant.$touch();
      this.$v.noRekening.$touch();
      this.$v.kodepos.$touch();
      this.$v.jenisUsaha.$touch();
      if (this.showMDRForm) {
        this.$v.mdrOnUs.$touch();
        this.$v.mdrOffUs.$touch();
      }
      if (this.isSpecialMdr) {
        this.$v.mdrFile.$touch();
      }
      this.$v.merchantModel.$touch();
      this.$v.merchantCriteria.$touch();
      this.$v.companyName.$touch();
      this.$v.merchantName.$touch();
      this.$v.merchantOwnerName.$touch();
      this.$v.noKTP.$touch();
      this.$v.noNPWP.$touch();
      this.$v.email.$touch();
      this.$v.noHandphone.$touch();
      this.$v.noHandphoneMerchant.$touch();
      this.$v.alamatMerchant.$touch();
      this.$v.bcko.$touch();
      this.$v.cmer.$touch();
      this.$v.rmReferalCode.$touch();
      this.$v.noTelpMerchant.$touch();
      if (this.isAPI && this.isVersionSnap) {
        this.$v.callbackPartnerId.$touch();
        this.$v.callbackPartnerClientSecret.$touch();
        this.$v.callbackPartnerUrlToken.$touch();
        this.$v.privateKeyPartner.$touch();
      }
      if (this.jenisQR === '2') {
        this.$v.endpointURL.$touch();
      }
      this.$v.IDApprover1.$touch();
      this.$v.IDApprover2.$touch();
      if (this.$refs.qrChannelField) {
        this.$refs.qrChannelField.touchValidation();
      }
      if (this.$refs.callbackPartnerField) {
        this.$refs.callbackPartnerField.touchValidation();
      }
      if ((this.isFromAggregator || this.isOutlet) && this.isIncludeAPI && this.$refs.aggregatorInterfaceField) {
        this.$refs.aggregatorInterfaceField.touchValidation();
      }
      return true;
    },

    touchStep2() {
      this.setFileFocus();
      this.$v.ktpFile.$touch();
      this.$v.npwpFile.$touch();
      this.$v.fotoMerchantFile.$touch();
      this.$v.qrisFile.$touch();
      this.$v.nmid.$touch();
      return true;
    },

    changeSubStep(step) {
      const validateAndSetStep = (touchStepFn, validateStepFn) => {
        if (touchStepFn) {
          if (validateStepFn) {
            this.subStep = step;
          } else {
            this.scrollToErrorInput();
          }
        }
      };

      switch (true) {
        case step === 2 && this.subStep === 1:
          validateAndSetStep(this.touchStep1(), this.validateStep1);
          break;
        case step === 3 && this.subStep === 2:
          validateAndSetStep(this.touchStep2(), this.validateStep2);
          break;
        default:
          this.subStep = step;
      }
    },
    prevStep() {
      const answer = window.confirm(
        'if you go back, your data in this page will be lost. continue ?'
      );
      if (answer) {
        this.$store.commit('register/setStep', 4);
      }
    },
    async checkQRIS() {
      const qrisIndex = this.allFile.findIndex((x) => x.doc_type == '4');
      if (qrisIndex != -1) this.allFile.splice(qrisIndex, 1);
      this.$store.commit('register/setQrisError', false);
      if (this.qrisFile != null) {
        await this.$store
          .dispatch('register/uploadDocument', {
            date,
            file: this.qrisFile,
            nama: 'QRIS',
            doc_type: 4,
          })
          .then((response) => {
            if (response.data.success) {
              response.doc_type = '4';
              this.allFile.push(response);
              this.nmid = response.data.data;
            }
          });
      }
    },
    setFileFocus() {
      this.ktpFileFocus = 2;
      this.npwpFileFocus = 2;
      this.fotoMerchantFileFocus = 2;
    },
    async nextStep() {
      await this.setFileFocus();
      this.done = true;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let registerType = '1';
        if (
          this.$route.params.id != undefined &&
          this.$route.params.idAggregator == undefined
        ) {
          registerType = '2';
        } else if (
          this.$route.params.id == undefined &&
          this.$route.params.idAggregator != undefined
        ) {
          registerType = '3';
        } else if (
          this.$route.params.id != undefined &&
          this.$route.params.idAggregator != undefined
        ) {
          registerType = '4';
        }

        const allData = {
          merchant_model: this.merchantModel,
          province_name: this.namaProvinsi,
          city_name: this.namaKabupaten,
          sub_district_name: this.namaKecamatan,
          urban_name: this.namaKelurahan,
          mcc: this.jenisUsaha.mcc,
          mdr_on_us: this.mdrOnUs,
          mdr_off_us: this.mdrOffUs,
          merchant_name: this.merchantName,
          owner_name: this.merchantOwnerName,
          ktp_no: this.noKTP,
          npwp_no: this.noNPWP,
          merchant_criteria: this.merchantCriteria.value,
          postal_code: this.namaKodepos,
          address: this.alamatMerchant,
          bcko: this.bcko ? (this.bcko.id || this.bcko.branch_code_bcko || '') : '',
          cmer: this.cmer ? (this.cmer.id || this.cmer.code || '') : '',
          referral_code: this.rmReferalCode,
          documents: this.allFile,
          nmid: this.nmid == null ? '' : this.nmid,
          company_name: this.companyName,
          phone: this.noTelpMerchant,
          phone_area_code: this.areaCode,
          approver_1: this.IDApprover1.user_id,
          approver_2: this.IDApprover2.user_id,
          mid: this.mid,
          tid: this.tid,
          client_partner_id: this.callbackPartnerId,
          client_partner_secret: this.callbackPartnerClientSecret,
          public_key_inbound: this.privateKeyPartner,
          access_token_endpoint: this.callbackPartnerUrlToken,
          endpoint: this.endpointURL,
          merchant_mobile_phone: this.noHandphoneMerchant,
          id_merchant:
            this.$route.params.id != undefined ? this.$route.params.id : '',
          id_aggregator:
            this.$route.params.idAggregator != undefined
              ? this.$route.params.idAggregator
              : '',
          type_registrasi: registerType,
          ip_address: this.ipAddress,
          parent_account_type: this.accountTypeParent,
          notif_sticker_status: this.submerchantNotif,
          mdr_file: this.isSpecialMdr ? this.mdrFile : null,
        };

        this.saveRegistration(allData);
      } else {
        this.scrollToErrorInput();
      }
    },

    async saveRegistration(allData) {
      const response = await this.$store.dispatch('register/saveRegistration', {
        date,
        all_data: allData,
        isIncludeAPI: this.isIncludeAPI,
      });

      if (response) {
        this.$store.commit('register/clearData');
        this.allFile = [];
        this.$store.commit('register/setReferenceNumber', response);
        this.$store.commit('register/setStep', 7);
        return;
      }

      const qrisUploaded = this.allFile.find((x) => x.doc_type == '4');
      this.allFile = [];
      if (qrisUploaded != undefined) this.allFile.push(qrisUploaded);

      if (!this.hasFieldErrors) return;

      if (!this.validateStep1) {
        this.subStep = 1;
      } else if (!this.validateStep2) {
        this.subStep = 2;
      }
      this.scrollToErrorInput();
    },

    scrollToErrorInput() {
      const keys = Object.keys(this.$v);
      let isError = false;

      keys.forEach((key) => {
        const input = key;

        if (input.includes('$')) return;

        if (this.$v[input].$error) {
          const element = document.getElementById(input);
          if (element) {
            this.$vuetify.goTo(`#${input}`, scrollOptions);
            isError = true;
          }
        }
      });

      if (!isError) this.$vuetify.goTo(0);
    },

    text,

    printThePDF(pdfFile) {
      printJS(pdfFile);
    },

    // MDR File Upload Methods
    onMdrFileChange(file) {
      this.mdrFile = file;
      if (file) {
        this.$v.mdrFile.$touch();
      }
    },
    onMdrFileRemove() {
      this.mdrFile = null;
      this.$v.mdrFile.$reset();
    },
    previewMdrFile() {
      if (this.mdrFile) {
        const fileURL = URL.createObjectURL(this.mdrFile);
        window.open(fileURL, '_blank');
      }
    },
    downloadMdrFile() {
      if (this.mdrFile) {
        const fileURL = URL.createObjectURL(this.mdrFile);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = this.mdrFile.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(fileURL);
      }
    },
  },
};
</script>

<style>
.v-text-field__suffix, 
.mdi-orbit-variant::before {
  color: #e56c26;
}
</style>
<style scoped>
.fixed-height-textarea ::v-deep .v-input__slot {
  max-height: 100px !important;
}

.fixed-height-textarea ::v-deep textarea {
  line-height: 1.2;
  font-family: monospace;
  overflow-y: auto !important;
}

.mdr-file-preview-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

.file-name-text {
  flex: 1;
  font-size: 14px;
  color: #333;
  word-break: break-all;
}
</style>